import * as React from "react";
import styled, { css } from "styled-components";
import isEqual from "lodash/isEqual";
import { useTranslation } from "react-i18next";
import useDebouncedValue from "hooks/useDebouncedValue";
import PDFPreview, { Canvas } from "report/report-creation/PDFPreview";
export const REPORT_PREVIEW_ID = "report-preview";
const PreviewDisabledCanvas = styled(Canvas)(
  ({ theme }) => css`
    background-color: ${theme.colors.global.background};
    align-items: center;
  `
);
const ReportPreview = ({ report, missingParameters }) => {
  var _a;
  const { t } = useTranslation("enterprise_report");
  const [debouncedReport] = useDebouncedValue(report, 200);
  const format = (_a = report.layout) == null ? void 0 : _a.format;
  const isPDF = !format || format === "PDF";
  if (isPDF && missingParameters) {
    return /* @__PURE__ */ React.createElement(PreviewDisabledCanvas, null, t("report_preview.disabled_missing_parameters"));
  }
  return isPDF ? /* @__PURE__ */ React.createElement(PDFPreview, { report: debouncedReport }) : /* @__PURE__ */ React.createElement(PreviewDisabledCanvas, null, t("report_preview.no_preview", { format }));
};
const PROPERTIES_FOR_PREVIEW = [
  "title",
  "subtitle",
  "description",
  "logo",
  "hideWidgetDescription",
  "hideWidgetQuery",
  "timezone",
  "parameterValues"
];
const compareProperties = (entity, entity2, keys) => keys.every((key) => (entity == null ? void 0 : entity[key]) === (entity2 == null ? void 0 : entity2[key]));
const layoutEqualForPreview = (layout1, layout2) => compareProperties(layout1, layout2, [
  "format",
  "orientation",
  "pageSize",
  "printToc",
  "header",
  "footer",
  "printHeader",
  "printFooter",
  "printPageNumbers"
]);
const widgetsEqualForPreview = (widgets1, widgets2) => isEqual(widgets1, widgets2);
const positionsEqualForPreview = (positions1, positions2) => isEqual(positions1, positions2);
const areReportsEqualForPreview = ({ report: report1, missingParameters: missingParameters1 }, { report: report2, missingParameters: missingParameters2 }) => missingParameters1 === missingParameters2 && compareProperties(report1, report2, PROPERTIES_FOR_PREVIEW) && layoutEqualForPreview(report1.layout, report2.layout) && widgetsEqualForPreview(report1.widgets, report2.widgets) && positionsEqualForPreview(report1.positions, report2.positions);
export default React.memo(ReportPreview, areReportsEqualForPreview);
